import React, { Component } from "react"

class ComparisonPercentage extends Component {
  calculateDifference(base, compare) {
    if (!base || !compare) return 0
    const difference = base - compare
    if (difference === 0) return 0
    return (difference / base * 100).toFixed(0)
  }

  formatDifference(value) {
    return value.toString().replace("-", "")
  }

  render() {
    const difference = this.calculateDifference(this.props.base, this.props.compare)

    return (
      <span>
        {this.formatDifference(difference)}%
        {difference > 0 && <i className="mdi mdi-arrow-up-bold" style={{ color: "green" }} />}
        {difference < 0 && <i className="mdi mdi-arrow-down-bold" style={{ color: "red" }} />}
        {difference === 0 && <i className="mdi mdi-arrow-right-bold" />}
      </span>
    )
  }
}

export default ComparisonPercentage



// WEBPACK FOOTER //
// ./src/Components/Graphs/Shared/ComparisonPercentage.js